module.exports = __webpack_public_path__ + "static/media/layout-6.d5c1a77d.svg";